import {
  DynamicTabs,
  PageWrapper,
  UserTopCover,
  generateAvatarInitialsImage,
} from '@repo/ui';
import { getProfileTypeFromName } from 'domain/value-objects/profile-type';
import { clearSelectedProfessionalData } from 'presentation/config/store/professionals/professional-overview-slice';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';

import { useProfessionalOverview } from '../../hooks/useProfessionalOverview';
import { useProfessionalOverviewTabs } from '../../hooks/useProfessionalOverviewTabs';
import { ProfessionalManagementForm } from './preRegistrationForm';
import { ProfissionalOverviewDetails } from './profissional-overview-details';
import { getEnv } from 'shared/get-env';

export const ProfessionalOverview = () => {
  // Hooks
  const dispatch = useDispatch();
  const {
    professionalType,
    selectedProfessionalData,
    navigate,
    id,
    requestGetProfessionalById,
  } = useProfessionalOverview();
  const { activeTabId, setActiveTab } = useProfessionalOverviewTabs();

  const fallbackAvatar = useMemo(() => {
    const name = selectedProfessionalData?.name;
    if (selectedProfessionalData?.avatar || !name) return undefined;
    return generateAvatarInitialsImage(name, 50);
  }, [selectedProfessionalData?.avatar, selectedProfessionalData?.name]);

  const avatarToShow = useMemo(() => {
    if (!selectedProfessionalData) {
      return 'placeholder-loading-avatar';
    }
    return selectedProfessionalData.avatar || fallbackAvatar;
  }, [selectedProfessionalData, fallbackAvatar]);

  useEffect(() => {
    if (
      !activeTabId ||
      !['visao-geral', 'dados-cadastrais'].includes(activeTabId)
    ) {
      setActiveTab('visao-geral');
    }
  }, [activeTabId, setActiveTab]);

  // Effects
  useEffect(() => {
    return () => {
      dispatch(clearSelectedProfessionalData());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!selectedProfessionalData && id) {
      requestGetProfessionalById({
        id,
        professionalType: getProfileTypeFromName(professionalType),
      });
    }
  }, [
    selectedProfessionalData,
    id,
    professionalType,
    requestGetProfessionalById,
  ]);

  return (
    <PageWrapper title="Visão Geral de Profissional">
      <UserTopCover
        cover={getEnv('REACT_APP_ORGANIZATION_COVER_URL') || ''}
        avatar={avatarToShow}
        name={selectedProfessionalData?.name || ''}
        profiles={
          selectedProfessionalData?.profileName
            ? [selectedProfessionalData.profileName]
            : []
        }
        iconLabels={[
          {
            icon: 'map-pin',
            label: selectedProfessionalData?.city?.name || '-',
          },
        ]}
        expandableAvatar
        isLoading={!selectedProfessionalData}
        goBack={() => navigate(`/equipe/${professionalType}`)}
      />

      <Row>
        <Col>
          <DynamicTabs
            tabs={[
              {
                id: 'visao-geral',
                label: 'Visão Geral',
                tabContent: <ProfissionalOverviewDetails />,
              },
              {
                id: 'dados-cadastrais',
                label: 'Cadastro',
                tabContent: <ProfessionalManagementForm />,
              },
            ]}
            variant="pills"
            navClassName="animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
            defaultActiveTabId={activeTabId}
            onTabChange={setActiveTab}
            rerenderOnClickActiveTab={true}
          />
        </Col>
      </Row>
    </PageWrapper>
  );
};
